<p>add-schedule-modal works!</p>
